import React, { FC } from 'react';
import cls from './WeeksModeStage.module.css';
import classNames from 'classnames';
import moment from 'moment';
import { StageItem } from '../../../../../../UI/StageItem/StageItem';

export const WeekItemStage = ({ stage, week, isPlanFact }) => {
    const stageDate = moment(stage.planned.start_date).format('DD.MM.YYYY');

    const nowDate = moment().format('DD.MM.YYYY');

    const isRenderDays = week.days.includes(stageDate) || week.days.includes(nowDate);

    return (
        <div className={classNames(cls.week, { [cls.factWrapper]: isPlanFact })}>
            {isRenderDays &&
                week.days.map((day) => (
                    <div
                        key={day + Math.random().toString(36)}
                        data-id={day}
                        className={classNames(cls.day, {
                            [cls.factWrapper]: isPlanFact,
                            [cls.nowDate]: day === nowDate,
                        })}
                    >
                        {stageDate === day && <StageItem isPlanFact={isPlanFact} stage={stage} />}
                    </div>
                ))}
        </div>
    );
};
